import { useSelector } from 'react-redux';

const useIsUsingV4Codes = () => {
  const { mealsCodingVersion } = useSelector(({ Company }) => Company);

  return mealsCodingVersion === 'v4';
};

export default useIsUsingV4Codes;
